import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion, AnimatePresence } from 'framer-motion';
import { Dialog, Box, Paper } from '@material-ui/core';
import { varFadeInUp } from '../fade/FadeIn';
export function DialogAnimate({ open = false, animate, onClose, children, ...other }) {
    return (_jsx(AnimatePresence, { children: open && (_jsx(Dialog, Object.assign({ fullWidth: true, maxWidth: "xs", open: open, onClose: onClose, PaperComponent: (props) => (_jsxs(Box, Object.assign({ component: motion.div }, (animate || varFadeInUp), { sx: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }, { children: [_jsx(Box, { onClick: onClose, sx: { width: '100%', height: '100%', position: 'fixed' } }, void 0), _jsx(Paper, Object.assign({}, props, { children: props.children }), void 0)] }), void 0)) }, other, { children: children }), void 0)) }, void 0));
}
//# sourceMappingURL=DialogAnimate.js.map